import React from 'react'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'
import { Typography, makeStyles } from '@material-ui/core'

import SimpleDialog from 'app/componentV4/Dialog/SimpleDialog'

const useStyles = makeStyles({
  root: {
    '& .MuiDialog-paper': {
      minWidth: '350px',
      maxWidth: '500px',
      maxHeight: '500px',
      overflowX: 'auto',
      padding: '2.5rem',
    },
  },
})

const Additional = (props) => {
  const { text, isOpen, onClose } = props
  const classes = useStyles()
  const { formatMessage } = useIntl()

  return (
    <SimpleDialog
      id={'metrics-subscriber-list'}
      open={isOpen}
      title={
        <div className="my-auto">
          <Typography className="text-18 font-bold text-primary">
            {formatMessage({
              id: 'timeline.detail.message.poll.additional.title',
            })}
          </Typography>
        </div>
      }
      onClose={onClose}
      className={classes.root}
    >
      <Typography className="text-14 text-grey-400 mt-10">{text}</Typography>
    </SimpleDialog>
  )
}

Additional.propTypes = {
  text: PropTypes.string,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
}

export default Additional
